import React, { useState } from 'react';
import styled from 'styled-components';
import useLocale from '../../hooks/useLocale';
import { CHANAKYA_COLORS } from './chanakyaColors';

const ToggleLink = styled.button`
  background: none;
  border: none;
  color: ${p => p.theme.colors.text.muted};
  font-size: 13px;
  cursor: pointer;
  padding: ${p => p.theme.spacing[2]}px 0;
  text-decoration: underline;
  margin-top: ${p => p.theme.spacing[5]}px;
`;

const Box = styled.div`
  max-width: 600px;
  margin: ${p => p.theme.spacing[3]}px auto 0;
  padding: ${p => p.theme.spacing[4]}px;
  background: ${CHANAKYA_COLORS.parchment};
  border: 1px solid ${CHANAKYA_COLORS.cellBorder};
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.7;
  color: ${p => p.theme.colors.text.secondary};
  text-align: left;
  font-family: 'Noto Sans Tamil', ${p => p.theme.typography.fontFamily};

  p { margin: 0 0 ${p => p.theme.spacing[2]}px; }
  p:last-child { margin-bottom: 0; }
`;

const Title = styled.h3`
  font-size: 15px;
  color: ${CHANAKYA_COLORS.primaryDark};
  margin: 0 0 ${p => p.theme.spacing[2]}px;
  font-weight: 600;
`;

const AboutChanakya = ({ lang }) => {
  const t = useLocale(lang, 'chanakyaNiti');
  const [expanded, setExpanded] = useState(false);

  return (
    <div>
      <ToggleLink onClick={() => setExpanded(!expanded)} aria-expanded={expanded}>
        {expanded ? (t.aboutToggleOpen || 'Close') : (t.aboutToggleClosed || 'Who was Chanakya?')}
      </ToggleLink>
      {expanded && (
        <Box>
          <Title>{t.aboutToggleClosed || 'Who was Chanakya?'}</Title>
          <p>{t.aboutWho || 'Chanakya (Kautilya) was an ancient Indian scholar, advisor to Chandragupta Maurya (~300 BCE), author of the Arthashastra and Niti Shastra.'}</p>
          <p>{t.aboutText || 'The Niti Shastra is a collection of aphorisms on governance, strategy, relationships, and ethics.'}</p>
          <p>{t.aboutHow || '36 aphorisms arranged in a 6×6 grid. Each cell maps to one aphorism tagged with a theme.'}</p>
          <p>{t.aboutIntention || 'Consult for perspective on decisions, strategy, or relationships. A reflection on classical wisdom.'}</p>
        </Box>
      )}
    </div>
  );
};

export default AboutChanakya;
